// extracted by mini-css-extract-plugin
export default {"fila":"Banderas_fila__8zORH","bandera":"Banderas_bandera__wX6PL"};